Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.BitmapFilterQuality = module.exports.default = {
	HIGH: 3,
	MEDIUM: 2,
	LOW: 1
};